let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4qZYJ")).then(() => parcelRequire('bfWEp'));